import { useState } from "react";
import { useNavigate } from "react-router-dom";
import fetchService from "../lib/fetchService";

export default function LoginButton() {
  const navigate = useNavigate();
  const [loginState, setLoginState] = useState(fetchService.isLoggedIn());
  // nicht fertig daher ausblenden
  return null
  if (loginState) {
    return (
      <button
        className="w3-button w3-text-red"
        onClick={() => {
          fetchService.logout();
          window.location.reload();
        }}
      >
        Logout
      </button>
    )
  }
  return (
    <button
      className="w3-button"
      onClick={() => {
        navigate('/login');
      }}
    >
      Login
    </button>
  )
}